module.exports = "<div class=\"bg-video\">\n  <div class=\"bg-video__content\">\n    <video class=\"bg-video__video\" muted loop autoplay v-bind:style=\"style\">\n      <source src=\"/static/videos/e-crown_1.mp4\" type=\"video/mp4\">\n    </video>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/bg-video/index.html
// module id = 8S7V
// module chunks = 1